

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { ProvinceList } from "../../components/ProvinceList";


export const ProvinceListPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Province List"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Province List", navigateTo: "/province/list" }
      ]}
      mainContents={<ProvinceList />}
    />
  );
};
